<template>
  <div>
    <a-form
      v-if="changePasswordType === 0"
      id="formChangePassword"
      class="user-layout-change-password"
      :form="form"
      @submit.prevent="handleChangePassword"
    >
      <h3><span>{{$t('userChangePassword.changePassword')}}</span></h3>
      <!-- 账户名 -->
      <a-form-item>
        <a-input
          class="change-password-input"
          size="large"
          type="text"
          :placeholder="$t('userChangePassword.usernameTxt')"
          v-decorator="[
            'loginName',
            {
              rules: [{ validator: validateLoginName }],
              validateTrigger: 'change'
            }
          ]"
        >
          <a-icon slot="prefix" type="user" :style="{color:'rgba(0,0,0,.25)'}"/>
        </a-input>
      </a-form-item>
      <!-- 密码 -->
      <a-popover
        placement="rightTop"
        :trigger="['focus']"
        :getPopupContainer="(trigger) => trigger.parentElement"
        v-model="showPasswordTip">
        <template slot="content">
          <div :style="{ width: '240px' }" >
            <div :class="['user-change-password', passwordLevelClass]">
              {{$t('userChangePassword.passwordStrength')}}：
              <span>{{ passwordLevelName }}</span>
            </div>
            <a-progress :percent="passwordStrength" :showInfo="false" :strokeColor=" passwordLevelColor " />
            <div style="margin-top: 10px;">
              <span>{{$t('userChangePassword.passwordTips')}}</span>
            </div>
          </div>
        </template>

        <a-form-item>
          <a-input-password
            size="large"
            type="password"
            @focus="()=>{showPasswordTip = true}"
            @blur="()=>{showPasswordTip = false}"
            autocomplete="false"
            :placeholder="$t('userChangePassword.passwordTxt')"
            v-decorator="[
              'password',
              {
                rules: [
                  { validator: this.handlePasswordLevel }
                ],
                validateTrigger: ['change', 'blur']
              }
            ]"
          >
            <a-icon slot="prefix" type="lock" :style="{ color: 'rgba(0,0,0,.25)' }"/>
          </a-input-password>
        </a-form-item>

      </a-popover>
      <!-- 确认密码 -->
      <a-form-item>
        <a-input-password
          size="large"
          type="password"
          autocomplete="false"
          :placeholder="$t('userChangePassword.repasswordTxt')"
          v-decorator="[
            'repassword',
            {
              rules: [
                { validator: this.handlePasswordCheck }
              ],
            validateTrigger: ['change', 'blur']
            }
          ]"
        >
          <a-icon slot="prefix" type="lock" :style="{ color: 'rgba(0,0,0,.25)' }"/>
        </a-input-password>
      </a-form-item>
      <!-- 修改密码手机 -->
      <a-form-item>
        <a-input
          size="large"
          placeholder="绑定的手机号"
          disabled
          v-decorator="['mobile']"
          >
          <a-icon slot="prefix" type="mobile" :style="{ color: 'rgba(0,0,0,.25)' }"/>
        </a-input>
      </a-form-item>
      <!-- 手机验证码 -->
      <a-row :gutter="16">
        <a-col class="gutter-row" :span="16">
          <a-form-item>
            <a-input
              size="large"
              type="text"
              :placeholder="$t('userChangePassword.varifyCodeTxt')"
              :maxLength="6"
              v-decorator="[
                'verifyCode',
                {
                  rules: [{ required: true, message: $t('userChangePassword.varifyCodeBlank') }],
                  validateTrigger: 'blur'
                }
              ]"
            >
              <a-icon slot="prefix" type="mail" :style="{ color: 'rgba(0,0,0,.25)' }"/>
            </a-input>
          </a-form-item>
        </a-col>
        <a-col class="gutter-row" :span="8">
          <a-button
            class="phone-verify-code-btn"
            size="large"
            :disabled="gettingVerifyCode || !userId"
            @click.stop.prevent="handleGetPhoneVerifyCode"
            v-text="!gettingVerifyCode && $t('userChangePassword.varifyCodeBtn')||(timeCountDown+' s')"></a-button>
        </a-col>
      </a-row>
      <a-form-item>
        <a-button
          size="large"
          type="primary"
          htmlType="submit"
          class="change-password-button"
          :loading="btnSubmit"
          :disabled="btnSubmit">{{$t('userChangePassword.changePasswordBtn')}}
        </a-button>
        <router-link class="login" :to="{ name: 'userLogin' }">{{$t('userChangePassword.backLoginBtn')}}</router-link>
      </a-form-item>

      <div class="lang-select">
        <span
          :class="lang === 'zh_CN' ? 'checked' : ''"
          @click="()=>{changeLang('zh_CN')}"
        > 中文 </span> /
        <span
          :class="lang === 'en_US' ? 'checked' : ''"
          @click="()=>{changeLang('en_US')}"
        > English </span>
      </div>
    </a-form>
    <div v-if="changePasswordType === 1">
      <a-result
        status="success"
        :title="$t('userChangePassword.changePasswordSuccess')"
        :subTitle="$t('userChangePassword.changePasswordSuccessBrief')"
      >
        <template v-slot:extra>
          <router-link to="/user/login">
            <a-button type="primary">{{$t('userChangePassword.backLoginBtn')}}</a-button>
          </router-link>
        </template>
      </a-result>
    </div>
    <Verify
      @success="sendSuccess"
      :mode="'pop'"
      :captchaType="'blockPuzzle'"
      :imgSize="{ width: '330px', height: '155px' }"
      ref="verify"
    ></Verify>
  </div>
</template>

<script>
import Verify from '@/components/verifition/Verify'
import { mapMutations, mapState } from 'vuex';
import { changePassword, sendChangePasswordPhoneCode, getUserInfoByName } from '@/api/userMana';

// const levelNames = {
//   0: '低',
//   1: '低',
//   2: '中',
//   3: '强'
// }
const levelClass = {
  0: 'error',
  1: 'error',
  2: 'warning',
  3: 'success'
}
const levelColor = {
  0: '#ff0000',
  1: '#ff0000',
  2: '#ff7e05',
  3: '#52c41a'
}

export default {
  name: 'changePassword',
  components: {Verify},
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  data() {
    return {
      changePasswordType: 0, // 修改密码状态 0：还没修改密码；1：修改密码成功

      btnSubmit: false, // 是否正在提交修改密码

      showPasswordTip: false, // 密码强度提示框
      passwordLevel: 0, // 设置密码的等级
      passwordStrength: 10, // 密码强度在强度条中的百分比

      gettingVerifyCode: false, // 是否已经点击‘获取验证码’
      timeCountDown: 60, // 获取手机验证码倒计时

      loginName: '',
      loginNameTimer: undefined,
      userId: ''
    }
  },
  computed: {
    ...mapState(['lang']),

    passwordLevelClass () {
      return levelClass[this.passwordLevel]
    },
    passwordLevelName () {
      switch (this.passwordLevel) {
        case 2:
          return this.$t('userChangePassword.passwordLevel2')
        case 3:
          return this.$t('userChangePassword.passwordLevel3')
        default:
          return this.$t('userChangePassword.passwordLevel1')
      }
      // return levelNames[this.passwordLevel]
    },
    passwordLevelColor () {
      return levelColor[this.passwordLevel]
    }
  },
  created () {},
  methods: {
    ...mapMutations(['changeLang']),

    validateLoginName (rule, value, callback) {
      clearTimeout(this.loginNameTimer)
      this.loginNameTimer = setTimeout(async () => {
        if (!value) {
          this.form.setFieldsValue({ mobile: '' });
          callback(this.$t('userChangePassword.usernameBlank'))
          return
        }
        if (value !== this.loginName) {
          try {
            const res = await getUserInfoByName({ loginName: value })

            const data = res.data.collection[0];
            this.form.setFieldsValue({ mobile: data.phone });
            this.userId = data.id;
            callback()
          } catch (error) {
            this.form.setFieldsValue({ mobile: '' });
            this.userId = '';
            if (error.response.data.message) {
              callback(error.response.data.message)
            }
          }
        }
      }, 1000)
    },

    handleChangePassword() {
      this.form.validateFields(async (err, values) => {
        // console.log('------handleChangePassword-------', err, values)
        if (!err) {
          try {
            this.btnSubmit = true
            await changePassword({
              password: values.password,
              token: values.verifyCode,
              userId: this.userId
            })
            this.$notification.success({
              message: this.$t('userChangePassword.changePasswordSuccess'),
              description: this.$t('userChangePassword.changePasswordSuccessBrief')
            });
            // this.btnSubmit = false
            // this.changePasswordType = 1
            this.resetPhoneCode()
            this.$router.push({ name: 'userLogin' })
          } catch (error) {
            this.btnSubmit = false
          }
        }
      })
    },

    // 判断输入密码是否为空、是否强度不够
    handlePasswordLevel (rule, value, callback) {
      let level = 0
      // 判断这个字符串中有没有数字
      if (/[0-9]/.test(value)) {
        level++
      }
      // 判断字符串中有没有字母
      if (/[a-zA-Z]/.test(value)) {
        level++
      }
      // 判断字符串中有没有特殊符号
      if (/[^0-9a-zA-Z_]/.test(value)) {
        level++
      }
      this.passwordLevel = level
      this.passwordStrength = level * 30

      if (!value || value.length < 8 || value.length > 16) {
        callback(new Error(this.$t('userChangePassword.passwordBlank')))
        return
      }

      if (level >= 2) {
        if (level >= 3) {
          this.passwordStrength = 100
        }
        callback()
      } else {
        if (level === 0) {
          this.passwordStrength = 10
        }
        callback(new Error(this.$t('userChangePassword.passwordWarn')))
      }
    },
    // 判断密码输入是否一致
    handlePasswordCheck (rule, value, callback) {
      const password = this.form.getFieldValue('password')
      // console.log('value', value)
      if (!value) {
        callback(new Error(this.$t('userChangePassword.repasswordBlank')))
      }
      if (value && password && value.trim() !== password.trim()) {
        callback(new Error(this.$t('userChangePassword.repasswordWarn')))
      }
      callback()
    },

    // 触发获取验证码
    async handleGetPhoneVerifyCode () {
      // 先验证手机号，再请求验证码
      this.form.validateFields(['mobile'], { force: true }, async (err, values) => {
        if (!err) {
          this.$refs.verify.show()
        }
      })
    },

    //发送验证码
    sendSuccess(data){
      console.log(data)
      // 先验证手机号，再请求验证码
      this.form.validateFields(['mobile'], { force: true }, async (err, values) => {
        console.log(err, values)
        if (!err) {
          try {
            let param = {
                "browserInfo": "",
                "captchaFontSize": 0,
                "captchaFontType": "",
                "captchaId": "",
                "captchaOriginalPath": "",
                "captchaType": "blockPuzzle",
                "captchaVerification": data.captchaVerification,
                "clientUid": "",
                "jigsawImageBase64": "",
                "originalImageBase64": "",
                "point": {
                  "secretKey": "",
                  "x": 0,
                  "y": 0
                },
                "pointJson": "",
                "pointList": [{
                  "x": 0,
                  "y": 0
                }],
                "projectCode": "",
                "result": true,
                "secretKey": "",
                "token": "",
                "ts": 0,
                "wordList": []
            }
            // 发送验证码请求
            sendChangePasswordPhoneCode({userId: this.userId}, param).then(res=>{
              if (res && res.data.success){
                // 设置按钮禁用，且准备显示倒计时
                this.gettingVerifyCode = true;
                // 开启倒计时
                this.interval = setInterval(() => {
                  if (this.timeCountDown-- <= 0) this.resetPhoneCode()
                }, 1000);
                // 关闭请求等待提示框
                this.$notification.success({
                  message: this.$t('userRegister.varifyCodeSendSuccess'),
                  description: ''
                })
              }
            })
          } catch (error) {
            // 关闭请求等待提示框
            this.resetPhoneCode()
          }
        }
      })
    },

    // 重置发送手机验证码按钮
    resetPhoneCode() {
      // 关闭倒计时
      clearInterval(this.interval);
      // 重置倒计时时间
      this.timeCountDown = 60;
      // 恢复请求手机验证码按钮状态
      this.gettingVerifyCode = false;
    }
  }
}
</script>

<style lang="less">
  .user-change-password {

    &.error {
      color: #ff0000;
    }

    &.warning {
      color: #ff7e05;
    }

    &.success {
      color: #52c41a;
    }

  }

  .user-layout-change-password {
    .ant-input-group-addon:first-child {
      background-color: #fff;
    }
  }

  .ant-result-title, .ant-result-subtitle{
    color: #fff;
  }
</style>
<style lang="less" scoped>
.user-layout-change-password {
  padding: 60px;
  h3 {
    margin-bottom: 20px;
    font-size: 20px;
    color: white;
  }

  .change-password-button {
    width: 50%;
  }

  .login {
    float: right;
    line-height: 40px;
  }

  .lang-select {
    margin-bottom: 0;
    text-align:right;
    color: rgba(255, 255, 255, 0.5);
  }
  .lang-select>span{
    cursor: pointer;
  }
  .lang-select>span.checked{
    color: #1890ff;
  }
}
</style>
